import { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { Lock, LogIn } from 'lucide-react';
import { useAuth } from './AuthContext';
import { erroApi } from './api';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AdminLogin() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const entrar = async (e) => {
    e.preventDefault();
    setErro('');
    setCarregando(true);
    try {
      const resp = await fetch(`${API}/api/auth/login`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password: senha }),
      });
      if (!resp.ok) {
        const data = await resp.json().catch(() => ({}));
        setErro(erroApi(data.detail));
        return;
      }
      setUser(await resp.json());
      navigate('/admin', { replace: true });
    } catch {
      setErro('Não foi possível conectar. Tente novamente.');
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-mk-blue px-4">
      <div data-testid="admin-login" className="w-full max-w-sm rounded-3xl bg-white p-8 shadow-2xl">
        <div className="flex flex-col items-center gap-2 text-center">
          <img src="/logo.png" alt="MK Eletromóveis" className="h-16 w-16 rounded-full" />
          <h1 className="font-heading text-xl font-extrabold text-slate-900">Painel Administrativo</h1>
          <p className="text-sm text-slate-500">Acesso restrito ao lojista</p>
        </div>
        <form onSubmit={entrar} className="mt-6 space-y-4">
          <div>
            <label className="text-xs font-bold uppercase tracking-wide text-slate-500">E-mail</label>
            <input
              data-testid="admin-login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full rounded-xl border border-slate-300 px-4 py-3 text-sm outline-none focus:border-mk-blue focus:ring-2 focus:ring-mk-blue/20"
              placeholder="seu@email.com"
            />
          </div>
          <div>
            <label className="text-xs font-bold uppercase tracking-wide text-slate-500">Senha</label>
            <input
              data-testid="admin-login-password"
              type="password"
              required
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              className="mt-1 w-full rounded-xl border border-slate-300 px-4 py-3 text-sm outline-none focus:border-mk-blue focus:ring-2 focus:ring-mk-blue/20"
              placeholder="••••••••"
            />
          </div>
          {erro && (
            <p data-testid="admin-login-error" className="rounded-xl bg-red-50 px-4 py-2.5 text-sm font-medium text-mk-red">
              {erro}
            </p>
          )}
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={carregando}
            className="flex w-full items-center justify-center gap-2 rounded-full bg-mk-blue py-3.5 text-sm font-bold text-white transition-colors hover:bg-mk-bluelight disabled:opacity-60"
          >
            {carregando ? 'Entrando...' : (<><LogIn size={17} /> Entrar no painel</>)}
          </button>
        </form>
        <a href="/" className="mt-5 flex items-center justify-center gap-1.5 text-xs font-semibold text-slate-400 hover:text-mk-blue">
          <Lock size={12} /> Voltar ao catálogo
        </a>
      </div>
    </div>
  );
}
